<template>
    <div
        class="o-p-qr-widget"
        :style="componentStyles"
    >

        <div class="o-p-qr-widget__header">
            {{$t(componentParams.header, 'Skanna QR-koden för att få kartan på din mobil')}}
        </div>
        <div class="o-p-qr-widget__code-wrapper">
            <component
                :is="qrComponent"
            />
            <video 
                autoplay 
                loop 
                muted 
                class="o-p-qr-widget__video"
                v-if="isShowVideo"
            >
                <source :src="videoUrl" type="video/mp4">
            </video>
        </div>
        <div class="o-p-qr-widget__info">
            <div class="o-p-qr-widget__info-logo">
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'OPQrWidget',
    components: {
        OQrCodeGenerator: () => import('../o-qr-code-generator/o-qr-code-generator'),
        OCustomQrCodeGenerator: () => import('../o-custom-qr-code-generator/o-custom-qr-code-generator')
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(['getMapConfigProp']),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPQrWidget.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPQrWidget.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPQrWidget.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPQrWidget.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        qrComponent() {
            return this.componentParams.qr_component || 'OCustomQrCodeGenerator';
        },
        isShowVideo() {
            return !!this.componentParams.video_url
        },
        videoUrl() {
            // video example https://assets.codepen.io/6093409/river.mp4
            return this.componentParams.video_url
        }
    },
}
</script>

<style lang="scss">
@import "o-p-qr-widget";
</style>
